// AppWithSocket.tsx
import React from "react";
import { Provider } from 'react-redux';
import { useAuth, AppSocketProvider } from "@/shared/hooks";
import { store } from '@/store';
import { AuthReduxSync } from '@/store/AuthReduxSync';
import App from "./App";
import NoCrown from '@/assets/GHChess1.png';

function AppWithSocket() {
  const { firebaseUser, loading } = useAuth(); // Get firebaseUser from useAuth

  if (loading)
    return (
          <div
            style={{
              backgroundColor: "#acffc3",
              height: "100vh",
              width: "100vw",
              margin: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
          <img width="525" height="350" alt="logo" src={NoCrown} style={{ marginBottom: '10px'}}></img>
      </div>
    );

  return (
    // Redux Provider wraps the entire app for state management
    <Provider store={store}>
      {/* Sync auth context user ID to Redux for global availability */}
      <AuthReduxSync>
        {/* Pass the firebaseUser (which is FirebaseUser | null) to AppSocketProvider */}
        <AppSocketProvider user={firebaseUser}>
          <App />
        </AppSocketProvider>
      </AuthReduxSync>
    </Provider>
  );
}

export default AppWithSocket;

